import { Stack } from '@mui/material';
import { ContentDivider } from '@upheal/design-system/components/ContentDivider/ContentDivider';
import { DashedGrid } from '@upheal/shared/components/shared/DashedGrid/DashedGrid';
import { ReactNode } from 'react';

type PromoBannerCardProps = {
    header: ReactNode;
    cta: ReactNode;
    features: ReactNode;
};

export const PromoBannerCard = ({
    header,
    cta,
    features,
}: PromoBannerCardProps) => (
    <Stack
        sx={{
            alignItems: 'center',
            overflow: 'clip',
            width: '100%',
            border: '1px solid',
            borderColor: 'ds.border.accent1.primary',
            borderRadius: (theme) => theme.borders.ds.borderRadius.md,
        }}
    >
        <DashedGrid sx={{ borderBottom: 0 }}>
            <Stack gap={2} alignItems="center" py={5}>
                {header}
                {cta}
            </Stack>
        </DashedGrid>
        <ContentDivider sx={{ alignSelf: 'stretch' }} />
        <Stack gap={1.25} py={4} px={2}>
            {features}
        </Stack>
    </Stack>
);
